import React, { memo, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import ActivityItem from './ActivityItem';
import DividendActivityItem from './DividendActivityItem';
import InterestActivityItem from './InterestActivityItem';
import OperationActivityItem from './OperationActivityItem';
import ProductTransferActivityItem from './ProductTransferActivityItem';
import StatementActivityItem from './StatementActivityItem';
import SwitchActivityItem from './SwitchActivityItem';
const InvestActivityRow = ({ item, isFirstIndex }) => {
    const content = useMemo(() => {
        if ('type' in item) {
            if (item.type === 'buy' || item.type === 'sell') {
                return (<ActivityItem item={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
            if (item.type === 'dividend') {
                return (<DividendActivityItem item={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
            if (item.type === 'switch') {
                return (<SwitchActivityItem item={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
            if (item.type === 'interest') {
                return (<InterestActivityItem item={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
            if (item.type === 'withdraw') {
                return (<OperationActivityItem item={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
            if (item.type === 'deposit') {
                return (<OperationActivityItem item={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
            if (item.type === 'isa_transfer_in') {
                return (<ProductTransferActivityItem activity={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
            if (item.type === 'jisa_transfer_in') {
                return (<ProductTransferActivityItem activity={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
            }
        }
        if ('month' in item && item.url) {
            return (<StatementActivityItem item={item} withWrapper isLastInSection={item.isLastInSection} isFirstInSection={item.isFirstInSection}/>);
        }
        return null;
    }, [item]);
    if ('sectionTitle' in item) {
        return (<SectionHeader horizontalMargins largeVerticalMargins={!isFirstIndex} style={isFirstIndex ? styles.firstSectionHeaderItem : undefined}>
        {item.sectionTitle}
      </SectionHeader>);
    }
    if ('type' in item || ('month' in item && item.url)) {
        return content;
    }
    return null;
};
const styles = StyleSheet.create({
    firstSectionHeaderItem: {
        paddingTop: rem(16),
        paddingBottom: rem(16),
    },
});
export default memo(InvestActivityRow);
